<template>
  <form class="flex flex-wrap w-full" @submit.prevent="submit">
    <div class="w-full md:w-1/2 mb-2 px-2">
      <nx-input
        v-model="data.name"
        :errors="form.errors"
        id="name"
        type="text"
        label="Name"
        maxlength="100"
        :focus="true"
      />
    </div>

    <div class="w-full md:w-1/2 mb-2 px-2">
      <nx-input
        v-model="data.username"
        :errors="form.errors"
        id="username"
        type="text"
        label="Username"
        maxlength="50"
      />
    </div>

    <div class="w-full mb-2 px-2">
      <nx-input
        v-model="data.email"
        label="Email"
        id="email"
        info="You cannot change your email."
        disabled
      />
    </div>

    <div class="flex flex-wrap w-full mb-2">
      <div class="w-full md:w-1/2 mb-2 px-2 md:mb-0">
        <nx-input
          v-model="data.password"
          :errors="form.errors"
          id="password"
          type="password"
          label="Password"
          minlength="8"
          maxlength="30"
        />
      </div>

      <div class="w-full md:w-1/2 px-2">
        <nx-input
          v-model="data.password_confirmation"
          :errors="form.errors"
          id="password_confirmation"
          type="password"
          label="Password Confirmation"
          minlength="8"
          maxlength="30"
        />
      </div>

      <p
        v-if="!form.errors.has('password')"
        class="text-sm mt-1 px-3 text-blue-8"
      >Optional. Leave blank to keep your current password.</p>
    </div>

    <div class="w-full md:w-1/2 mb-2 px-2">
      <nx-input
        v-model="data.location"
        :errors="form.errors"
        id="location"
        type="text"
        label="Location"
        info="Optional"
        maxlength="100"
      />
    </div>

    <div class="w-full md:w-1/2 mb-2 px-2">
      <nx-select
        v-model="selectedTimezone"
        :options="timezones"
        id="timezone"
        track-by="value"
        option-label="name"
        group-label="group"
        group-values="zones"
        :errors="form.errors"
        label="Timezone"
        :info="'Current time in ' + selectedTimezone.name + ' is ' + currentTimeInTimezone"
      ></nx-select>
    </div>

    <div class="flex w-full mb-2 px-2">
      <nx-richtextarea
        v-model="data.signature"
        :simple="true"
        :include-emotes="true"
        :include-links="true"
        :include-images="true"
        :errors="form.errors"
        label="Signature"
        id="signature"
      />
    </div>

    <div class="w-full px-2 mb-4">
      <nx-button native-type="submit" :diabled="loading">{{ loading ? 'Loading..' : 'Submit' }}</nx-button>
    </div>
  </form>
</template>

<script>
import Form from "form-backend-validation"
import timezones from "@/timezones"
import DateTime from "@/mixins/DateTime"
import { find, flatten, map } from "lodash"

export default {
  name: "UserUpdateForm",
  mixins: [DateTime],
  props: {
    user: {
      required: true
    }
  },
  data() {
    return {
      form: new Form(),
      loading: false,
      data: null,
      timezones: timezones,
      selectedTimezone: null
    }
  },
  watch: {
    user: {
      handler(val) {
        this.data = {
          name: val.name,
          username: val.username,
          email: val.email,
          signature: val.signature,
          location: val.location,
          password: "",
          password_confirmation: ""
        }
        this.selectedTimezone = find(
          this.timezoneOptions,
          item => item.value === val.timezone
        )
      },
      immediate: true
    },
    selectedTimezone(val) {
      if (!val) return
      this.data.timezone = val.value
    }
  },
  computed: {
    currentTimeInTimezone() {
      if (!this.selectedTimezone) return ""
      return this.nowInTimezone(this.selectedTimezone.value)
    },
    timezoneOptions() {
      return flatten(map(this.timezones, item => item.zones))
    }
  },
  methods: {
    submit() {
      this.$api.self
        .update(this.data)
        .then(() => {
          this.$toasted.success("Your profile has been updated.")
          this.$emit("success")
        })
        .catch(data => {
          if (data.response && data.response.status === 422) {
            this.form.onFail(data)
            this.$error.form()
          } else {
            this.$error.generic()
          }
        })
    }
  }
}
</script>
